


















import { Component } from 'vue-property-decorator';

import Menu from '../components/Menu.vue';
import EventDetail from '@/components/EventDetail.vue';
import StumpExample from '@/components/StumpExample.vue';
import Footer from '@/components/Footer.vue';
import MainImage from '@/components/MainImage.vue';
import {Mixins} from 'vue-mixin-decorator';
import PageVue from '@/script/PageVue';
import ParticipantDetail from '@/components/ParticipantDetail.vue';
import StumpExample2 from '@/components/StumpExample2.vue';
import {passwordVerify} from '@/script/Hash';

@Component({
  components: {StumpExample2, ParticipantDetail, MainImage, StumpExample, Footer, EventDetail, Menu },
})
export default class ParticipantInfoPage extends Mixins<PageVue>(PageVue) {
  private inputText: string = '';

  private mounted() {
    this.inputText = '';
    // window.console.log(passwordHash("ヒロアカ"));
  }

  private async onClickSend() {
    const result = passwordVerify(this.inputText, process.env.VUE_APP_KEY_WORD_HASH);
    if (result) {
      await this.$router.push({ name: 'Reward' });
    } else {
      alert('残念！\nキーワードが違います！');
    }
  }
}
